import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Helmet } from "react-helmet";
import { Toast } from '../components_root/ToastContext.jsx';
import Lodinging from "../components_root/loading.jsx";
import Lodingingimg from "../components_root/loadingimg.jsx";
import { MdAddAPhoto } from "react-icons/md";
import { Update_companytable_info } from '../components_root/update_company_table_info.js';
import logo_default from '../assets/logo_default.jpg';
import { Uploader_companies_files } from "../components_root/uploader_companies_files.js";

export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Meta_data() {

    const [websitedata, setwebsitedata] = useState(null);
    const [logo_file, setLogo_file] = useState(null);

    const [old_file_uid, setOld_file_uid] = useState("");
    const [logoUrl, setLogoUrl] = useState(logo_default);
    const [isLoading_banner, setIsLoading_banner] = useState(true);

    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const select_company_uid = Cookies.get("select_company_uid");

    // --------------------- LOAD WEBSITE DATA ------------------------

    const fetchCompany = async () => {
        try {
            const docRef = doc(db, "websiteservicesdb", select_company_uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {

                const data = {
                    id: docSnap.id,
                    ...docSnap.data(),
                };

                setwebsitedata(data);
                setLogoUrl(data.logo_url || logo_default);
                setOld_file_uid(data.logo_uid || "null");

            } else {
                setwebsitedata(null);
            }
        } finally {
            setIsLoading_banner(false);
        }
    };
    useEffect(() => {
        fetchCompany();
    }, []);

    // ---------------------- UPLOAD LOGO ----------------------------
    const logo_Upload = async () => {
        if (!logo_file) return;
        if (!old_file_uid) return;
        if (!Cookies.get("guid")) return Toastshow("Please login");
        if (!select_company_uid) return Toastshow("Please select company");

        const result = await Uploader_companies_files({
            servicetablename: "websiteservicesdb",
            file: logo_file,
            fileuid: select_company_uid,
            tablename: "websiteservicesdb",
            filename: "logo",
            old_file_uid,
        });

        if (result.success) {
            Toastshow("Successfully!");
            setLogo_file(null);
            fetchCompany();
        } else {
            Toastshow(`Error: ${result.error}`);
            setLogo_file(null);
        }
    };

    useEffect(() => {
        if (logo_file) {
            logo_Upload();
        }
    }, [logo_file]);


    const Update_info = async (filename, fileuid, textinfo) => {
        if (!filename?.trim()) return { success: false, error: "Missing filename" };
        if (!fileuid?.trim()) return { success: false, error: "Missing fileuid" };
        if (!textinfo?.trim()) return { success: false, error: "Missing textinfo" };

        const result = await Update_companytable_info({
            servicetablename: "websiteservicesdb",
            filename,
            fileuid,
            textinfo
        });

        if (result.success) {
            Toastshow("Saved successfully");
        } else {
            Toastshow(result.error);
        }

        return result;
    };


    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_size">

                {/* ---------------- LOGO BLOCK ---------------- */}
                <div className='m-1 p-1'>

                    <table>
                        <tbody>
                            <tr>
                                <td width={100}>
                                    <div className="logo-div">
                                        {isLoading_banner ? (
                                            <Lodinging />
                                        ) : (
                                            <>
                                                <img
                                                    src={logoUrl}
                                                    alt="logo"
                                                    className="logo_url"
                                                />

                                                <div className="change_image flex center">
                                                    {logo_file !== null ? (
                                                        <Lodingingimg />
                                                    ) : (
                                                        <label>
                                                            <MdAddAPhoto className="icon white cursor" />
                                                            <input
                                                                type="file"
                                                                accept=".jpg,.jpeg,.png"
                                                                style={{ display: "none" }}
                                                                onChange={(e) => {
                                                                    const selectedFile = e.target.files[0];
                                                                    if (selectedFile) {
                                                                        setLogo_file(selectedFile);
                                                                        setLogoUrl(URL.createObjectURL(selectedFile));
                                                                    }
                                                                }}
                                                            />
                                                        </label>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* ---------------- SHOW WEBSITE DATA ---------------- */}
                     <div className='rounded m-1'>
                    <table>
                        <tr>
                            <td className='text-h2 text-off bold fcap' width={100}>website id</td>
                            <td className='text-h2 bold'>{Cookies.get("website_uid")}</td>
                         
                        </tr>
                    </table>
                </div>
                       <div className='rounded m-1'>
                    <table>
                        <tr>
                            <td className='text-h2 text-off bold fcap' width={100}>Create</td>
                            <td className='text-h2 bold'> {websitedata?.date_time.toDate().toLocaleDateString()}{" "}
                                                                                            {websitedata?.date_time.toDate().toLocaleTimeString()}</td>
                         
                        </tr>
                    </table>
                </div>
                     <div className='rounded m-1'>
                    <table>
                        <tr>
                            <td className='text-h2 text-off bold fcap' width={100}>Doamin</td>
                            <td><textarea className='text-h2' maxLength={60} defaultValue={websitedata?.domain_registration} id="domain_registration_input" placeholder='Enter domain name' /></td>
                            <div
                                className="button-ui text-h2 m-1 cursor"
                                onClick={() =>
                                    Update_info(
                                        "domain_registration",
                                        websitedata?.suid,
                                        document.getElementById("domain_registration_input").value
                                    )
                                }
                            >
                                Save
                            </div>
                        </tr>
                    </table>
                </div>
                <div className='rounded m-1'>
                    <table>
                        <tr>
                            <td className='text-h2 text-off bold fcap' width={100}>Title</td>
                            <td><textarea className='text-h2' maxLength={60} defaultValue={websitedata?.title} id="title_input" placeholder='Enter Title' /></td>
                            <div
                                className="button-ui text-h2 m-1 cursor"
                                onClick={() =>
                                    Update_info(
                                        "title",
                                        websitedata?.suid,
                                        document.getElementById("title_input").value
                                    )
                                }
                            >
                                Save
                            </div>
                        </tr>
                    </table>
                </div>
                <div className='rounded m-1'>
                    <table>
                        <tr>
                            <td className='text-h2 text-off bold fcap' width={100}>description</td>
                            <td><textarea
                                className="text-h2"
                                maxLength={150}
                                defaultValue={websitedata?.description}
                                id="description_input"
                                placeholder="Enter Title"
                            /></td>
                            <div
                                className="button-ui text-h2 m-1 cursor"
                                onClick={() =>
                                    Update_info(
                                        "description",
                                        websitedata?.suid,
                                        document.getElementById("description_input").value
                                    )
                                }
                            >
                                Save
                            </div>
                        </tr>
                    </table>
                </div>
                     <div className='rounded m-1'>
                    <table>
                        <tr>
                            <td className='text-h2 text-off bold fcap' width={100}>keywords (,)</td>
                            <td><textarea
                                className="text-h2"
                                maxLength={300}
                                defaultValue={websitedata?.keywords}
                                id="keywords_input"
                                placeholder="Enter Title"
                            /></td>
                            <div
                                className="button-ui text-h2 m-1 cursor"
                                onClick={() =>
                                    Update_info(
                                        "keywords",
                                        websitedata?.suid,
                                        document.getElementById("keywords_input").value
                                    )
                                }
                            >
                                Save
                            </div>
                        </tr>
                    </table>
                </div>
            </div>

        </div>
    );
}
